import { PickingInfo } from "deck.gl";

import { getDeckInstance } from "src/js/plugins/deck.gl/deckInstance";
import { SelectionType } from "src/js/stores/map/store";
import { SitesClusteredViewportSearchMapLayer } from "react-migration/domains/sites/map/SitesClusteredViewportSearchMapLayer";
import { getDeckLayerInstanceIds } from "react-migration/lib/map/getLayerInstances";
import { SitesMVTLayer } from "react-migration/domains/sites/map/SitesMVTLayer";

import { ClickSelectionResolver } from "../../types";
import { SELECTION_HANDLERS } from "../../selection_types/SelectionHandlers";
import { SitesGeoJsonLayer } from "../SitesLayerType/SitesGeoJsonLayer";
import { isSiteBoundary } from "../SitesLayerType/utils";

export const sitesClickResolver: ClickSelectionResolver = async (pickInfo: PickingInfo<unknown>) => {
  const { x, y } = pickInfo;
  const deck = getDeckInstance();
  const layerIds = getDeckLayerInstanceIds([SitesGeoJsonLayer, SitesMVTLayer, SitesClusteredViewportSearchMapLayer]);

  for (const pick of deck?.pickMultipleObjects({ x, y, layerIds }) || []) {
    const siteSelection = await sitePickResolver(pick);

    if (siteSelection) return siteSelection;
  }

  return null;
};

export async function sitePickResolver(pick: PickingInfo<unknown>) {
  if (!isSiteBoundary(pick.object)) return;

  const type = pick.object.properties.shared ? SelectionType.SHARED_SITE : SelectionType.SITE;
  const selectionHandler = SELECTION_HANDLERS[type];

  if (!selectionHandler) {
    console.error(`No selection handler found for site selection of type: ${type}`);
    return;
  } else if (!selectionHandler.selectionResolver) {
    console.error(`No selection resolver found for site selection of type: ${type}`);
    return;
  }

  return selectionHandler.selectionResolver(pick.object.properties.id);
}
